interface Props {
    className?: string
    FillColor?: string
}

export default function Package({className, FillColor = 'black'}:Props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" className={className}>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M12.2206 3.03317C12.0768 2.98894 11.9232 2.98894 11.7794 3.03317L2.02944 6.03317C1.71474 6.12999 1.5 6.42075 1.5 6.75V17.25C1.5 17.5793 1.71474 17.87 2.02944 17.9668L11.7794 20.9668C11.9232 21.0111 12.0768 21.0111 12.2206 20.9668L21.9706 17.9668C22.2853 17.87 22.5 17.5793 22.5 17.25V6.75C22.5 6.42075 22.2853 6.12999 21.9706 6.03317L12.2206 3.03317ZM21 7.76547L17.6268 8.80337V12H17.6244V13.2371C17.6244 13.4028 17.49 13.5371 17.3244 13.5371C16.6616 13.5371 16.1244 12.9998 16.1244 12.3371V12H16.1268V9.26491L12.75 10.3039V19.2345L21 16.6961V7.76547ZM3 7.76547L11.25 10.3039V19.2345L3 16.6961V7.76547ZM12 8.9653L4.80028 6.75L7.31248 5.97701L14.5122 8.19231L12 8.9653ZM9.86277 5.19231L17.0625 7.4076L19.1997 6.75L12 4.5347L9.86277 5.19231Z"
                  fill={FillColor} />
        </svg>
    )
}
